import { Box, Typography } from '@mui/material';

export const Screen9BusinessValue = ({ selectedIndustry }) => {
  if (!selectedIndustry) return null;

  return (
    <div className="p-6">
      <Typography fontSize={35} textAlign="center">
        Business Value
      </Typography>
      <Typography fontSize={24} mt={4} lineHeight={1}>
        Solving your business challenges drives:
      </Typography>
      <Box ml={4}>
        {selectedIndustry.BusinessValue.map((value, index) => (
          <Typography key={index} component="li" fontSize={22} mt={2} lineHeight={1.3}>
            {value}
          </Typography>
        ))}
      </Box>
    </div>
  );
};
